'use strict';

namespace Core {

    class ScStarRating {
        rating: number;
        stars: string[][];

        private iconClass: string = 'icon-star';

        constructor (
            private $scope: ng.IScope
        ) {
            this.$scope.$watch('sr.rating', (val) => {
                if (!(this.rating > -1)) {
                    return;
                }
                const ceiling: number = Math.ceil(this.rating);
                const hasHalf = this.rating < ceiling;
                if (ceiling) {
                    this.stars = _.map(new Array(ceiling), (v, index) => {
                        const classes: string[] = [];
                        classes.push(this.iconClass);
                        if (hasHalf && (index === ceiling - 1)) {
                            classes.push('star-rating__half');
                        }
                        return classes;
                    });
                }
            });
        }
    }

    angular
        .module('core')
        .directive('scStarRating', (): ng.IDirective => {

            return {
                scope: {},
                controller: ScStarRating,
                controllerAs: 'sr',
                bindToController: {
                    rating: '='
                },
                template: `<span class="star-rating">
                                <i ng-class="r.join(' ')" ng-repeat="r in sr.stars track by $index"></i>
                            </span>`,
                replace: true
            };

        });

}
